module.exports = __webpack_public_path__ + "img/orange_101.48a42cc9.png";